module.exports = __webpack_public_path__ + "static/media/logodv.05d00c3c.png";